import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import {makeLogger} from '../../../../logger/logger';
import type {InternalAddressesStrategyData} from '../../types/internal-addresses-strategy-data.type';
import {InternalAddressesStrategyService} from '../../InternalAddressesStrategyService';

const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/internal-address-services/internal-address-faqs.service.ts'});

@Service({id: 'internalAddressesProfaceStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<InternalAddressesStrategyService> {

  build(details: InternalAddressesStrategyData): InternalAddressesStrategyService {
      return new InternalAddressesStrategyProface(details);
  }
}

export class InternalAddressesStrategyProface extends InternalAddressesStrategyService {
  details;

  constructor(details: InternalAddressesStrategyData) {
      super();
      this.details = details;
  }

  isExternalLink(link: string):boolean {
      try {
        const follow = new URL(link);

        const internalDomains = [
          'https://proface.com',
          'proface.com',
          'www.proface.com'
        ];

        if (follow.hostname) {
          return (
            !internalDomains.includes(follow?.hostname) &&
                    window.location.hostname !== follow?.hostname
          );
        } else {
          return false;
        }
      } catch (e) {
        err('Encountered an unexpected problem while validating external links');
        return false;
      }
  }
}
